export const IS_DEV = process.env.NODE_ENV !== "production";
export const IS_ELECTRON = navigator.userAgent.toLowerCase().indexOf(" electron/") >= 0;
